import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode, useState } from 'react'

import { isClientError } from '#/shared/api/api-error'

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Admin data is reference data, read far more often than it changes.
        // A short stale window removes most refetches while a tab is in use.
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        // A 4xx will fail identically on every attempt — retrying only delays
        // the error the user needs to see.
        retry: (failureCount, error) => !isClientError(error) && failureCount < 2,
      },
      mutations: {
        retry: false,
      },
    },
  })
}

export function QueryProvider({ children }: { children: ReactNode }) {
  // Created in state, not at module scope: a module-level client would be
  // shared across tests and leak cache between them.
  const [queryClient] = useState(createQueryClient)

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
